/* eslint-disable no-nested-ternary */
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-size: 12px;
    color: red;
    margin-top: 4px;
  }
`;

export const ContainerInput: any = styled.div`
  display: flex;
  height: 44px;
  width: 100%;
  border-radius: 8px;
  border-width: ${(props: any) => (props.isFocused ? 2 : 1)}px;
  border-style: solid;
  background-color: ${(props: any) =>
    props.disabled ? "rgba(0,0,0,0.08)" : "#ffffff"};
  border-color: ${(props: any) =>
    props.isFocused ? "#4a76fb" : props.isError ? "red" : "#C4C4C4"};
  transition: border-color 0.2s ease-in;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  overflow: hidden;
  &:hover {
    cursor: not-allowed;
  }
  input::placeholder {
    color: #a3a3a6;
  }
`;

export const Input = styled.input`
  display: flex;
  height: 42px;
  width: 100%;
  border-radius: 8px;
  background-color: transparent;
  border: none;
  padding: 0 14px 0 14px;
  color: #333;
  font-size: 16px;
  transition: all 0.5s ease-out;

  :focus {
    border: none;
    -webkit-appearance: none;
    outline: none;
  }
`;
